import { createSelector } from '@app/utils/createSelector'

import { createReduxSlice } from '@app/store/redux_slice'

const firebaseTokenSlice = createReduxSlice<string | null>('firebase_token')

export const firebaseTokenSelector = createSelector([firebaseTokenSlice.selector], token => token ?? null)

export const setFirebaseToken = (token: string) => firebaseTokenSlice.set(token)

export const clearFirebaseToken = () => firebaseTokenSlice.remove()
